import { ActionContext, ActionTree } from 'vuex';
import { AdpFileControlState } from '@/store/modules/adp-file-control/index';
import { RootState } from '@/store';
import {
  DOWNLOAD_ADP_FILES,
  GET_ADP_CUSTOMERS,
  GET_ADP_FILE,
  SET_ADP_CUSTOMERS,
  SET_ADP_CUSTOMERS_ERROR,
  SET_ADP_FILES,
  SET_ADP_FILES_ERRORS,
  SET_ADP_FILES_LOADING,
} from '@/types/adp-file-control.types';
import { AdpFileControlSearchModel } from '@/models/backoffice/AdpFileControlSearchModel';
import { finalize } from 'rxjs/operators';
import AdpFileControlService from '@/services/adp-file-control.service';
import { Grid } from '@/models/Grid.model';
import { DownloadFileRequest } from '@/models/request/DownloadFileRequest';
import { Utils } from '@/globals/Utils';
import { FileMimeType } from '@/models/FileMimeType';

export const adpFileControlService = new AdpFileControlService();

export const actions: ActionTree<AdpFileControlState, RootState> = {
  [GET_ADP_FILE]: (
    { commit, dispatch, state }: ActionContext<AdpFileControlState, RootState>,
    searchObject: AdpFileControlSearchModel,
  ) => {
    commit(SET_ADP_FILES_LOADING, true);
    adpFileControlService.getAdpFiles(searchObject)
      .pipe(
        finalize(() => commit(SET_ADP_FILES_LOADING, false)),
      )
      .subscribe(
        ({ results, resultCount }) => commit(SET_ADP_FILES, { results, resultCount }),
        error => commit(SET_ADP_FILES_ERRORS, error.messages),
      );
  },

  [GET_ADP_CUSTOMERS]: (
    { commit, dispatch, state }: ActionContext<AdpFileControlState, RootState>,
  ) => {
    adpFileControlService.getAdpCustomers()
      .subscribe(
        data => {
          const customerGrid = {
            results: data.customers,
            resultCount: data.customers!.length || 0,
          } as Grid;
          commit(SET_ADP_CUSTOMERS, customerGrid);
        },
        error => commit(SET_ADP_CUSTOMERS_ERROR, error.messages),
      );
  },
  [DOWNLOAD_ADP_FILES]: (
    { commit }: ActionContext<AdpFileControlState, RootState>,
    { fileName, fileId }: DownloadFileRequest,
  ) => {
    commit(SET_ADP_FILES_LOADING, true);

    adpFileControlService.downloadAdpFiles(fileId)
      .pipe(
        finalize(() => commit(SET_ADP_FILES_LOADING, false)),
      )
      .subscribe(
        data => {
          Utils.downloadBase64File(data.body, fileName, FileMimeType.TXT);
        },
        error => commit(SET_ADP_FILES_ERRORS, error.messages),
      );
  },
};
